import { registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import localeEn from '@angular/common/locales/en';
import localePl from '@angular/common/locales/pl';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { provideFirebaseApp } from '@angular/fire/app';
import { provideAuth, getAuth, connectAuthEmulator } from '@angular/fire/auth';
import { provideDatabase } from '@angular/fire/database';
import { connectFunctionsEmulator, FunctionsModule, getFunctions, provideFunctions } from '@angular/fire/functions';
import { connectStorageEmulator, getStorage, provideStorage } from '@angular/fire/storage';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';
import { NgIdleModule } from '@ng-idle/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GlobalErrorHandler } from './shared/error-handling/global-error-handler';
import { FireDbService } from './shared/services/fireDb.service';
import { SharedModule } from './shared/shared.module';
import { NavigationModule } from './view/navigation/navigation.module';
import { UserContextModule } from './view/user-context/user-context.module';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/locale/', '.json');
}

registerLocaleData(localePl);
registerLocaleData(localeEn);

FullCalendarModule.registerPlugins([dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin]);

@NgModule({
  declarations: [AppComponent],
  imports: [
    FunctionsModule,
    provideAuth(() => {
      if (environment.authEmulator) {
        const auth = getAuth();
        connectAuthEmulator(auth, 'http://localhost:9099');
        return auth;
      }
      return getAuth();
    }),
    provideFirebaseApp(() => {
      const app = FireDbService.initApp();
      FireDbService.initDatabases();
      if (environment.useEmulators) FireDbService.initDbEmulator();
      return app;
    }),
    provideDatabase(() => FireDbService.getDbRef(FireDbService.commonDbName)),
    provideStorage(() => {
      const storage = getStorage();
      if (environment.useEmulators) {
        connectStorageEmulator(storage, 'localhost', 9199);
      }
      return storage;
    }),
    provideFunctions(() => {
      const functions = getFunctions(undefined, 'us-central1');
      if (environment.useEmulators) {
        connectFunctionsEmulator(functions, 'localhost', 5001);
      }
      return functions;
    }),
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    BrowserModule,
    FullCalendarModule,
    SharedModule,
    MatSidenavModule,
    NavigationModule,
    UserContextModule,
    NgIdleModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pl-PL' },
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
